import router from "./router";
import store from "./store";
router.beforeEach(async (to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
      }
    if(to.path === '/login'){//登录界面放行
        next();
    } else{
        const hasGetUserInfo = store.state.name;//这里每次判断store里面的name
        if(hasGetUserInfo){
            next();
        } else{
            store.dispatch("info");
            next();//注意如果使用addRoutes()要改为next({ ...to, replace: true });否则无限循环错误
        }
    }
    
});